<!-- verify-timesheet-view.component.html -->
<!-- Add this section BEFORE the desktop .pc section in verify-timesheet-view.component.html -->

<!-- Mobile View Section -->
<div class="mobile-view d-md-none" style="position: relative; z-index: 300;">
  <div class="header pb-4 pt-5 pt-md-4"
    style="background-color: #fbb034;z-index: 50; background-image: linear-gradient(315deg, #ffdd00 0%, #fbb034 74%); height: 30px; margin-bottom: 16px;">
  </div>
  <div class="tw-bg-white tw-m-4 tw-p-3 -tw-mt-12 tw-relative tw-z-50 tw-rounded-lg">

    <div class="row">
      <div class="col">
        <div class="">
          <!-- Header -->
          <div class="card-headermobile tw-bg-white">
            <div class="mobile-card-header-info">
              <h3 class="mobile-title-header">
                <span class="tw-font-semibold tw-cursor-pointer tw-hover:underline" (click)="goBack()">
                  Verify Timesheet
                </span>
                &gt; {{ mainTimesheets.month | month }} &gt; <br>
                Name: {{ firstnameTimesheet }} {{ lastnameTimesheet }}
              </h3>

              <div class="mobile-period-info-header tw-text-right tw-pb-2">
                <span class="info-text-header tw-text-xs">
                  Timesheet Period {{ mainTimesheets.preriodFrom | date : "d MMMM y" }} To {{ mainTimesheets.preriodTo |
                  date : "d MMMM y" }}
                  จำนวน {{ manday.toFixed(2) }} Mandays
                  Total Travel Expenses {{ (sumCost >= 1000) ? (sumCost | number:'1.0-0') : sumCost }}
                </span>
              </div>

              <div *ngIf="showMobileAddForm && mainTimesheets.status == 'H' && mainTimesheets.leadId == currentUserID"
                class="tw-flex tw-justify-end tw-gap-3 tw-py-3 ">
                <button (click)="openMobileAddForm()"
                  class="tw-px-4 tw-py-1 tw-bg-green-500 tw-text-white tw-rounded-md tw-text-sm tw-font-semibold">
                  Add timesheet
                </button>
              </div>

              <div *ngIf="!showMobileAddForm && mainTimesheets.status == 'H' && mainTimesheets.leadId == currentUserID"
                class="tw-flex tw-justify-end tw-gap-3 tw-py-3 ">
                <button (click)="cancelMobileAddForm()"
                  class="tw-px-4 tw-py-1 tw-bg-gray-200 tw-rounded-md tw-text-sm tw-font-semibold">
                  Cancel
                </button>
              </div>
            </div>
          </div>

          <div>
            <!-- New Form Cards -->
            <div *ngIf="!showMobileAddForm">
              <div *ngFor="let card of mobileFormCards; let i = index"
                class="tw-bg-white tw-border tw-border-gray-300 tw-rounded-2xl tw-py-2 tw-px-4 tw-mb-4 tw-shadow-sm tw-relative">
                <!-- Remove Button -->
                <button (click)="removeMobileCard(card.id)"
                  class="tw-absolute -tw-top-2 -tw-right-2 tw-w-7 tw-h-7 tw-bg-red-500 tw-text-white tw-rounded-full tw-flex tw-items-center tw-justify-center tw-text-xl tw-font-bold tw-shadow-md hover:tw-bg-red-600 tw-z-10">−</button>

                <div>
                  <!-- Date Field -->
                  <div class="tw-mb-2 ">
                    <div class="tw-flex tw-items-center tw-gap-3">
                      <label class="tw-text-sm tw-text-gray-500 tw-font-normal tw-my-auto">Date:</label>
                      <input type="date" [(ngModel)]="card.dateStr" (change)="onMobileDateChange(card, card.dateStr)"
                        [min]="getMobileMinDate()" [max]="getMobileMaxDate()"
                        class="tw-flex-1 tw-px-2 tw-py-1 tw-border tw-border-gray-300 tw-rounded-lg tw-text-xs tw-font-semibold tw-text-gray-600"
                        [class.tw-text-gray-400]="!card.dateStr" placeholder="-- Date --">
                    </div>
                  </div>

                  <!-- Project Field -->
                  <div class="tw-mb-2">
                    <div class="tw-flex tw-items-start tw-gap-3">
                      <label class="tw-text-xs tw-text-gray-500 tw-font-normal tw-shrink-0 tw-my-auto">Project:</label>
                      <select [(ngModel)]="card.projectName" (change)="onMobileProjectChange(card)"
                        class="tw-flex-1 tw-min-w-0 tw-px-2 tw-py-1 tw-border tw-border-gray-300 tw-rounded-lg tw-text-xs tw-appearance-none tw-bg-white tw-font-semibold tw-text-gray-600">
                        <option value="">-- Select Project --</option>
                        <option *ngFor="let project of projects" [value]="project.projectName">
                          {{ project.projectName }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <!-- Time Row -->
                  <div class="tw-mb-2 ">
                    <div class="tw-grid tw-grid-cols-3 tw-gap-2">

                      <!-- Start -->
                      <div class="tw-flex tw-items-center tw-gap-1">
                        <label
                          class="tw-text-xs tw-text-gray-500 tw-font-normal tw-whitespace-nowrap tw-my-auto">Start:</label>
                        <input type="time" [(ngModel)]="card.startTime" (change)="onMobileTimeChange(card)" step="60"
                          class="tw-flex-1 tw-min-w-0 tw-px-1 tw-py-1 tw-border tw-border-gray-300 tw-rounded-lg tw-text-[10px] tw-font-semibold tw-text-gray-600 tw-bg-white">
                      </div>

                      <!-- End -->
                      <div class="tw-flex tw-items-center tw-gap-1">
                        <label
                          class="tw-text-xs tw-text-gray-500 tw-font-normal tw-whitespace-nowrap tw-my-auto">End:</label>
                        <input type="time" [(ngModel)]="card.endTime" (change)="onMobileTimeChange(card)" step="60"
                          class="tw-flex-1 tw-min-w-0 tw-px-1 tw-py-1 tw-border tw-border-gray-300 tw-rounded-lg tw-text-[10px] tw-font-semibold tw-text-gray-600 tw-bg-white">
                      </div>

                      <!-- Working Hours -->
                      <div class="tw-flex tw-items-center tw-gap-1">
                        <label
                          class="tw-text-xs tw-text-gray-500 tw-font-normal tw-whitespace-nowrap tw-my-auto">Hrs:</label>
                        <input type="text" [value]="card.workingHours" disabled
                          class="tw-flex-1 tw-min-w-0 tw-px-1 tw-py-1 tw-border tw-border-gray-300 tw-rounded-lg tw-text-xs tw-bg-gray-100 tw-text-center tw-font-semibold tw-text-gray-600">
                      </div>

                    </div>
                  </div>

                  <!-- Checkbox Row -->
                  <div class="tw-flex tw-items-center tw-gap-6 tw-mb-2 ">
                    <div class="tw-flex tw-items-center tw-gap-2 tw-px-2">
                      <input type="checkbox" [id]="'break_' + card.id" [(ngModel)]="card.isBreak"
                        (change)="onMobileBreakChange(card)"
                        class="tw-w-4 tw-h-4 tw-text-blue-600 tw-rounded tw-cursor-pointer tw-flex-shrink-0">
                      <label [for]="'break_' + card.id"
                        class="tw-text-xs tw-font-normal tw-text-gray-500 tw-my-auto tw-cursor-pointer">
                        Lunch Break
                      </label>
                    </div>

                    <div class="tw-flex tw-items-center tw-gap-2 tw-px-2">
                      <input type="checkbox" [id]="'onsite_' + card.id" [(ngModel)]="card.checkOnsite"
                        (change)="onMobileOnsiteChange(card)"
                        [disabled]="!card.selectedProject?.msProjectSites || card.selectedProject.msProjectSites.length === 0"
                        class="tw-w-4 tw-h-4 tw-text-blue-600 tw-rounded tw-flex-shrink-0"
                        [class.tw-cursor-pointer]="card.selectedProject?.msProjectSites && card.selectedProject.msProjectSites.length > 0"
                        [class.tw-cursor-not-allowed]="!card.selectedProject?.msProjectSites || card.selectedProject.msProjectSites.length === 0">
                      <label [for]="'onsite_' + card.id" class="tw-text-xs tw-font-normal tw-self-center"
                        [class.tw-text-gray-500]="card.selectedProject?.msProjectSites && card.selectedProject.msProjectSites.length > 0"
                        [class.tw-text-gray-400]="!card.selectedProject?.msProjectSites || card.selectedProject.msProjectSites.length === 0"
                        [class.tw-cursor-pointer]="card.selectedProject?.msProjectSites && card.selectedProject.msProjectSites.length > 0"
                        [class.tw-cursor-not-allowed]="!card.selectedProject?.msProjectSites || card.selectedProject.msProjectSites.length === 0">
                        Onsite
                      </label>
                    </div>
                  </div>

                  <!-- Site Field -->
                  <div *ngIf="card.checkOnsite && card.selectedProject?.msProjectSites?.length > 0" class="tw-mb-2 ">
                    <div class="tw-flex tw-gap-3 tw-items-start tw-gap-2">
                      <label class="tw-text-xs tw-text-gray-500 tw-font-normal tw-shrink-0 tw-my-auto">Site:</label>
                      <select [(ngModel)]="card.siteId"
                        class="tw-flex-1 tw-px-2 tw-py-1 tw-border tw-rounded-lg tw-text-xs tw-appearance-none tw-bg-white tw-font-semibold tw-text-gray-600 tw-text-right tw-break-words"
                        [class.tw-border-red-500]="card.checkOnsite && !card.siteId"
                        [class.tw-border-gray-300]="!card.checkOnsite || card.siteId">
                        <option value="">-- Select Site --</option>
                        <option *ngFor="let site of card.selectedProject.msProjectSites"
                          [value]="(site.id || site.siteId)">
                          {{ site.siteName }} — {{ site.siteCost }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <!-- Description Field -->
                  <div class="tw-flex tw-gap-3 tw-items-start">
                    <span class="tw-text-xs tw-text-gray-500 tw-font-normal tw-shrink-0 tw-my-auto">Desc:</span>
                    <textarea [(ngModel)]="card.description" rows="2"
                      class="tw-flex-1 tw-px-2 tw-rounded-lg tw-text-xs tw-resize-none tw-bg-white tw-font-semibold tw-text-gray-600 tw-break-words tw-leading-relaxed"
                      placeholder="กรอกรายละเอียดงาน..."></textarea>
                  </div>
                </div>
              </div>
            </div>

            <!-- Add More Card Button -->
            <div *ngIf="!showMobileAddForm"
              class="tw-mb-4 tw-border-2 tw-border-dashed tw-border-green-400 tw-rounded-2xl tw-p-3 tw-flex tw-justify-center tw-items-center">
              <button (click)="addNewMobileCard()"
                class="tw-w-14 tw-h-14 tw-bg-green-500 tw-text-white tw-rounded-full tw-flex tw-items-center tw-justify-center tw-text-3xl tw-font-bold tw-shadow-lg hover:tw-bg-green-600 tw-transition-colors">
                +
              </button>
            </div>

            <!-- Existing Timesheet Cards -->
            <div *ngFor="let card of existingMobileTimesheetCards; let i = index">
              <!-- VIEW MODE -->
              <div *ngIf="!card.isEditing"
                class="tw-bg-white tw-border tw-border-gray-300 tw-rounded-2xl tw-py-2 tw-px-4 tw-mb-4 tw-shadow-sm">
                <!-- Date Header -->
                <div class="tw-mb-2 tw-pb-1 tw-border-b tw-border-gray-200">
                  <div class="tw-flex tw-items-center tw-gap-3 ">
                    <span class="tw-text-sm tw-text-gray-500 tw-font-normal">Date:</span>
                    <span class=" tw-flex tw-items-center  tw-text-xs tw-font-semibold tw-text-gray-600 ">{{
                      card.dateStr | date:'d MMM. yyyy'
                      }}<span *ngIf="checkIsUpdateByManager(card.updatedBy) === true"
                        class="tw-text-red-500">*</span></span>
                  </div>
                </div>

                <!-- Time Row -->
                <div class="tw-grid tw-grid-cols-3 tw-gap-3 tw-mb-2 tw-pb-1 tw-border-b tw-border-gray-200">
                  <div class="tw-flex tw-flex-row tw-items-center tw-gap-2">
                    <span class="tw-text-xs tw-text-gray-500 tw-font-normal">Start</span>
                    <span class=" tw-flex tw-items-center tw-gap-1  tw-text-xs tw-font-semibold tw-text-gray-600 ">{{
                      card.startTime }}</span>
                  </div>
                  <div class="tw-flex tw-flex-row tw-items-center tw-gap-2">
                    <span class="tw-text-xs tw-text-gray-500 tw-font-normal">End</span>
                    <span class="tw-flex tw-items-center tw-gap-1  tw-text-xs tw-font-semibold tw-text-gray-600 ">{{
                      card.endTime }}</span>
                  </div>
                  <div class="tw-flex tw-items-center tw-justify-between">
                    <span class="tw-text-xs tw-text-gray-500">Working Hours</span>
                    <span class="tw-text-xs tw-font-semibold tw-text-gray-600">{{ card.workingHours }}</span>
                  </div>
                </div>

                <!-- Project -->
                <div class="tw-mb-2 tw-pb-1 tw-border-b tw-border-gray-200">
                  <div class="tw-flex tw-gap-3  tw-items-start tw-gap-2">
                    <span class="tw-text-xs tw-text-gray-500 tw-font-normal tw-shrink-0">Project:</span>
                    <span
                      class="tw-text-xs tw-flex tw-items-center tw-font-semibold tw-text-gray-600 tw-text-right tw-break-words">{{
                      card.projectName }}</span>
                  </div>
                </div>

                <!-- Site -->
                <div class="tw-mb-2 tw-pb-1 tw-border-b tw-border-gray-200">
                  <div class="tw-flex tw-gap-3  tw-items-start tw-gap-2">
                    <span class="tw-text-xs tw-text-gray-500 tw-font-normal tw-shrink-0">Site</span>
                    <span
                      class="tw-text-xs tw-flex tw-items-center tw-font-semibold tw-text-gray-600  tw-text-right tw-break-words">
                      <ng-container *ngIf="card.checkOnsite && card.siteId">
                        <ng-container *ngFor="let site of card.selectedProject?.msProjectSites">
                          <ng-container *ngIf="(site.id || site.siteId) == card.siteId">
                            {{ site.siteName }} — {{ site.siteCost }}
                          </ng-container>
                        </ng-container>
                      </ng-container>
                      <ng-container *ngIf="!card.checkOnsite || !card.siteId">-</ng-container>
                    </span>
                  </div>
                </div>

                <!-- Description -->
                <div class="tw-flex tw-gap-3 tw-items-center">
                  <span class="tw-text-xs tw-text-gray-500 tw-font-normal tw-shrink-0">Desc:</span>

                  <span
                    class="tw-text-xs tw-font-semibold tw-text-gray-600 tw-text-right tw-break-words tw-leading-relaxed">
                    {{ card.description || '-' }}
                  </span>
                </div>
                <!-- Edit Button -->
                <div class="tw-flex tw-justify-center tw-pt-1 tw-mt-1 tw-border-t tw-border-gray-200"
                  *ngIf="mainTimesheets.status == 'H' && mainTimesheets.leadId == currentUserID">
                  <img src="assets/img/icons/edit.png" alt="Edit" (click)="startEditingMobileCard(card)"
                    class="tw-w-6 tw-h-6 tw-cursor-pointer" />
                </div>
              </div>


              <!-- EDIT MODE -->
              <div *ngIf="card.isEditing"
                class="tw-bg-white tw-border tw-border-gray-300 tw-rounded-2xl tw-py-4 tw-px-4 tw-mb-4 tw-shadow-sm tw-relative">
                <!-- Delete Button (Red Circle with minus sign) -->
                <button type="button" (click)="deleteMobileTimesheetConfirm(card)"
                  class="tw-absolute -tw-top-2 -tw-right-2 tw-w-7 tw-h-7 tw-bg-red-500 tw-text-white tw-rounded-full tw-flex tw-items-center tw-justify-center tw-text-xl tw-font-bold tw-shadow-md hover:tw-bg-red-600 tw-z-10">
                  −
                </button>
                <!-- Date Field (Disabled) -->
                <div class="tw-mb-2 ">
                  <div class="tw-flex tw-items-center tw-gap-3">
                    <label class="tw-text-sm tw-font-normal tw-text-gray-500 tw-my-auto">Date:</label>
                    <span class="tw-flex tw-items-center tw-text-xs tw-font-semibold tw-text-gray-600">
                      {{ card.dateStr | date:'d MMM. yyyy' }}<span
                        *ngIf="checkIsUpdateByManager(card.updatedBy) === true" class="tw-text-red-500">*</span>
                    </span>
                  </div>
                </div>

                <!-- Project Field -->
                <div class="tw-mb-2 ">
                  <div class="tw-flex tw-items-start tw-gap-3">
                    <label class="tw-text-xs tw-text-gray-500 tw-font-normal tw-shrink-0 tw-my-auto">Project:</label>
                    <select [(ngModel)]="card.projectName" (change)="onMobileProjectChange(card)"
                      [disabled]="!card.canAction"
                      class="tw-flex-1 tw-min-w-0 tw-px-2 tw-py-1 tw-border tw-border-gray-300 tw-rounded-lg tw-text-xs tw-appearance-none tw-font-semibold tw-text-gray-600"
                      [class.tw-bg-gray-100]="!card.canAction" [class.tw-cursor-not-allowed]="!card.canAction"
                      [class.tw-bg-white]="card.canAction" [class.tw-cursor-pointer]="card.canAction">
                      <option value="">-- Select Project --</option>
                      <option *ngFor="let project of projects" [value]="project.projectName">
                        {{ project.projectName }}
                      </option>
                    </select>
                  </div>
                </div>


                <!-- Time Row -->
                <div class="tw-mb-2 ">
                  <div class="tw-grid tw-grid-cols-3 tw-gap-2">

                    <!-- Start -->
                    <div class="tw-flex tw-items-center tw-gap-1">
                      <label
                        class="tw-text-xs tw-text-gray-500 tw-font-normal tw-whitespace-nowrap tw-my-auto">Start:</label>
                      <input type="time" [(ngModel)]="card.startTime" (change)="onMobileTimeChange(card)"
                        class="tw-flex-1 tw-min-w-0 tw-px-1 tw-py-1 tw-border tw-border-gray-300 tw-rounded-lg tw-text-[10px] tw-font-semibold tw-text-gray-600"
                        [class.tw-bg-gray-100]="!card.canAction" [class.tw-cursor-not-allowed]="!card.canAction"
                        [class.tw-bg-white]="card.canAction">
                    </div>

                    <!-- End -->
                    <div class="tw-flex tw-items-center tw-gap-1">
                      <label
                        class="tw-text-xs tw-text-gray-500 tw-font-normal tw-whitespace-nowrap tw-my-auto">End:</label>
                      <input type="time" [(ngModel)]="card.endTime" (change)="onMobileTimeChange(card)"
                        class="tw-flex-1 tw-min-w-0 tw-px-1 tw-py-1 tw-border tw-border-gray-300 tw-rounded-lg tw-text-[10px] tw-font-semibold tw-text-gray-600"
                        [class.tw-bg-gray-100]="!card.canAction" [class.tw-cursor-not-allowed]="!card.canAction"
                        [class.tw-bg-white]="card.canAction">
                    </div>

                    <!-- Working Hours -->
                    <div class="tw-flex tw-items-center tw-gap-1">
                      <label
                        class="tw-text-xs tw-text-gray-500 tw-font-normal tw-whitespace-nowrap tw-my-auto">Hrs:</label>
                      <input type="text" [value]="card.workingHours" disabled
                        class="tw-flex-1 tw-min-w-0 tw-px-1 tw-py-1 tw-border tw-border-gray-300 tw-rounded-lg tw-text-xs tw-bg-gray-100 tw-text-center tw-font-semibold tw-text-gray-600">
                    </div>

                  </div>
                </div>




                <!-- Checkbox Row -->
                <div class="tw-flex tw-gap-6 tw-mb-1">
                  <div class="tw-flex tw-items-center tw-gap-2 tw-px-2">
                    <input type="checkbox" [id]="'edit_lunch_break_' + i" [(ngModel)]="card.isBreak"
                      (change)="onMobileBreakChange(card)" [disabled]="!card.canAction"
                      class="tw-w-4 tw-h-4 tw-text-blue-600 tw-rounded tw-cursor-pointer tw-flex-shrink-0"
                      [class.tw-cursor-not-allowed]="!card.canAction">
                    <label [for]="'edit_lunch_break_' + i" class="tw-text-xs tw-font-normal tw-my-auto"
                      [class.tw-text-gray-400]="!card.canAction" [class.tw-text-gray-500]="card.canAction"
                      [class.tw-cursor-not-allowed]="!card.canAction" [class.tw-cursor-pointer]="card.canAction">
                      Lunch Break
                    </label>
                  </div>

                  <div class="tw-flex tw-items-center tw-gap-2 tw-px-2">
                    <input type="checkbox" [id]="'edit_onsite_' + i" [(ngModel)]="card.checkOnsite"
                      (change)="onMobileOnsiteChange(card)"
                      [disabled]="!card.canAction || !card.selectedProject?.msProjectSites || card.selectedProject.msProjectSites.length === 0"
                      class="tw-w-4 tw-h-4 tw-text-blue-600 tw-rounded tw-flex-shrink-0"
                      [class.tw-cursor-not-allowed]="!card.canAction || !card.selectedProject?.msProjectSites || card.selectedProject.msProjectSites.length === 0"
                      [class.tw-cursor-pointer]="card.canAction && card.selectedProject?.msProjectSites && card.selectedProject.msProjectSites.length > 0">
                    <label [for]="'edit_onsite_' + i" class="tw-text-xs tw-font-normal tw-my-auto"
                      [class.tw-text-gray-400]="!card.canAction" [class.tw-text-gray-500]="card.canAction"
                      [class.tw-cursor-not-allowed]="!card.canAction" [class.tw-cursor-pointer]="card.canAction">
                      Onsite
                    </label>
                  </div>
                </div>

                <!-- Site Field -->
                <div *ngIf="card.checkOnsite && card.selectedProject?.msProjectSites?.length > 0" class="tw-mb-2 ">
                  <div class="tw-flex tw-gap-3 tw-items-start tw-gap-2">
                    <label class="tw-text-xs tw-text-gray-500 tw-font-normal tw-shrink-0 tw-my-auto">Site:</label>
                    <select [(ngModel)]="card.siteId" [disabled]="!card.canAction"
                      class="tw-flex-1 tw-px-2 tw-py-1 tw-border tw-rounded-lg tw-text-xs tw-appearance-none tw-font-semibold tw-text-gray-600 tw-text-right tw-break-words"
                      [class.tw-border-red-500]="card.checkOnsite && !card.siteId"
                      [class.tw-border-gray-300]="!card.checkOnsite || card.siteId"
                      [class.tw-bg-gray-100]="!card.canAction" [class.tw-cursor-not-allowed]="!card.canAction"
                      [class.tw-bg-white]="card.canAction" [class.tw-cursor-pointer]="card.canAction">
                      <option value="">-- Select Site --</option>
                      <option *ngFor="let site of card.selectedProject.msProjectSites"
                        [value]="(site.id || site.siteId)">
                        {{ site.siteName }} — {{ site.siteCost }}
                      </option>
                    </select>
                  </div>
                </div>

                <!-- Description Field -->
                <div class=" tw-pb-1">
                  <label class="tw-block tw-text-xs tw-font-normal tw-text-gray-500 tw-mb-1">Desc:</label>
                  <textarea [(ngModel)]="card.description" [disabled]="!card.canAction" rows="2"
                    class="tw-w-full tw-px-2 tw-py-1 tw-border tw-border-gray-300 tw-rounded-lg tw-text-xs tw-resize-none"
                    [class.tw-bg-gray-100]="!card.canAction" [class.tw-cursor-not-allowed]="!card.canAction"
                    [class.tw-bg-white]="card.canAction" placeholder="กรอกรายละเอียดงาน..."></textarea>
                </div>

                <!-- Save and Cancel Buttons -->
                <div class="tw-flex tw-justify-center tw-gap-3 tw-pt-1 tw-mt-1">
                  <button type="button" (click)="saveEditedMobileTimesheet(card)" [disabled]="!card.canAction"
                    class="tw-flex-1 tw-max-w-[120px] tw-px-4 tw-py-1.5 tw-rounded-lg tw-text-xs tw-font-semibold tw-text-white tw-bg-blue-500 hover:tw-bg-blue-600 tw-transition-colors"
                    [class.tw-opacity-50]="!card.canAction" [class.tw-cursor-not-allowed]="!card.canAction">
                    Save
                  </button>
                  <button type="button" (click)="cancelEditingMobileCard(card)"
                    class="tw-flex-1 tw-max-w-[120px] tw-px-4 tw-py-1.5 tw-rounded-lg tw-text-xs tw-font-semibold tw-text-gray-700 tw-bg-gray-200 hover:tw-bg-gray-300 tw-transition-colors">
                    Cancel
                  </button>
                </div>
              </div>
            </div>

          </div>

        </div>

        <div class="description-bar tw-flex tw-py-2 tw-px-5 tw-items-center tw-justify-between">

          <!-- LEFT: Description -->
          <span class="tw-justify-start tw-text-light tw-text-xs tw-text-blue-500 tw-cursor-pointer"
            (click)="toggleMobileBottomSheet()">
            Description
          </span>

          <!-- RIGHT: Button group -->
          <div class="tw-flex tw-gap-2 tw-justify-end">

            <!-- SAVE Button -->
            <div *ngIf="!showMobileAddForm && mainTimesheets.status == 'H'">
              <button
                class="tw-bg-green-500 tw-w-[100px] tw-font-medium tw-text-sm tw-rounded-xl tw-px-2 tw-py-1 tw-text-white"
                [disabled]="!isMobileSaveValid()" [class.tw-opacity-50]="!isMobileSaveValid()"
                [class.tw-cursor-not-allowed]="!isMobileSaveValid()" (click)="saveMobileForm()">
                Save
              </button>
            </div>

            <!-- ปุ่มอื่น ๆ แสดงเฉพาะเมื่อ Save ไม่แสดง -->
            <ng-container *ngIf="showMobileAddForm || mainTimesheets.status != 'H'">

              <!-- ADMIN -->
              <ng-container *ngIf="rolename.includes('ADMIN')">
                <button *ngIf="mainTimesheets.status == 'P' &&
                       (mainTimesheets.positionId == 3 || 
                        mainTimesheets.positionId == 5 || 
                        mainTimesheets.leadId == currentUserID)"
                  class="tw-bg-green-500 tw-w-[100px] tw-font-medium tw-text-sm tw-rounded-xl tw-px-2 tw-py-1 tw-text-white"
                  (click)="onClickApprove(mainTimesheets)">
                  Approve
                </button>

                <button *ngIf="mainTimesheets.status == 'P' &&
                       (mainTimesheets.positionId == 3 || 
                        mainTimesheets.positionId == 5 || 
                        mainTimesheets.leadId == currentUserID)"
                  class="tw-bg-blue-500 tw-w-[100px] tw-font-medium tw-text-sm tw-rounded-xl tw-px-2 tw-py-1 tw-text-white"
                  (click)="onClickRevise(mainTimesheets)">
                  Revise
                </button>

                <button *ngIf="mainTimesheets.status == 'M'"
                  class="tw-bg-green-500 tw-w-[100px] tw-font-medium tw-text-sm tw-rounded-xl tw-px-2 tw-py-1 tw-text-white"
                  (click)="onClickApprove(mainTimesheets)">
                  Approve
                </button>

                <button *ngIf="mainTimesheets.status == 'A' || mainTimesheets.status == 'M'"
                  class="tw-bg-blue-500 tw-px-2 tw-text-sm tw-rounded-xl tw-py-1 tw-text-white"
                  (click)="openDiaLogClick(modalHrRevise)">
                  HR Revise
                </button>

                <button *ngIf="mainTimesheets.leadId == currentUserID && mainTimesheets.status == 'H'"
                  class="tw-bg-green-500 tw-w-[100px] tw-font-medium tw-text-sm tw-rounded-xl tw-px-2 tw-py-1 tw-text-white"
                  (click)="onClickPendingHrApprove(mainTimesheets)">
                  Submit
                </button>
              </ng-container>

              <!-- [disabled]="!isSubmitBtnDisabled" -->

              <!-- MANAGER -->
              <ng-container *ngIf="rolename.includes('MANAGER')">
                <button *ngIf="mainTimesheets.status == 'P' &&
                       (mainTimesheets.positionId == 3 || 
                        mainTimesheets.positionId == 5 || 
                        mainTimesheets.leadId == currentUserID)"
                  class="tw-bg-green-500 tw-text-sm tw-rounded-xl tw-px-2 tw-py-1 tw-text-white"
                  (click)="onClickApprove(mainTimesheets)">
                  Approve
                </button>

                <button *ngIf="mainTimesheets.status == 'P' &&
                       (mainTimesheets.positionId == 3 || 
                        mainTimesheets.positionId == 5 || 
                        mainTimesheets.leadId == currentUserID)"
                  class="tw-bg-blue-500 tw-text-sm tw-rounded-xl tw-px-2 tw-py-1 tw-text-white"
                  (click)="onClickRevise(mainTimesheets)">
                  Revise
                </button>

                <button *ngIf="mainTimesheets.status == 'H'"
                  class="tw-bg-green-500 tw-w-[100px] tw-text-sm tw-rounded-xl tw-px-2 tw-py-1 tw-text-white"
                  (click)="onClickPendingHrApprove(mainTimesheets)">
                  Submit
                </button>
              </ng-container>

            </ng-container> <!-- End ปุ่มอื่น ๆ -->

          </div>
        </div>



      </div>
    </div>
  </div>
</div>

<!-- Mobile Bottom Sheet for Description and Actions -->
<div class="tw-fixed tw-inset-0 tw-bg-black/50 tw-z-[9998] tw-transition-opacity tw-duration-300"
  [ngClass]="isMobileBottomSheetOpen ? 'tw-opacity-100 tw-visible' : 'tw-opacity-0 tw-invisible'"
  (click)="toggleMobileBottomSheet()"></div>

<div
  class="tw-fixed tw-bottom-0 tw-left-0 tw-right-0 tw-bg-white tw-z-[9999] tw-transition-transform tw-duration-300 tw-max-h-[80vh] tw-shadow-[0_-4px_20px_rgba(0,0,0,0.15)]"
  [ngClass]="isMobileBottomSheetOpen ? 'tw-translate-y-0' : 'tw-translate-y-full'">
  <!-- Header -->
  <div class="tw-py-1 tw-border-b tw-border-[#E5E5EA] tw-flex tw-items-center tw-justify-center">
    <button
      class="tw-bg-transparent tw-border-none tw-text-[#8E8E93] tw-w-6 tw-h-6 tw-flex tw-items-center tw-justify-center tw-cursor-pointer hover:tw-text-black"
      (click)="toggleMobileBottomSheet()">
      <i class="fa fa-chevron-down"></i>
    </button>
  </div>

  <!-- Content -->
  <div class="tw-flex-1 tw-overflow-y-auto tw-p-5">

    <!-- For Add Mode - Show Validation Messages -->
    <div *ngIf="!showMobileAddForm">
      <div class="tw-mb-4">
        <h3 class="tw-text-sm tw-mb-3 tw-leading-relaxed">
          <strong class="tw-text-[#FF3B30] tw-font-semibold">*ต้องกรอกข้อมูลให้ครบถึงจะกด Save ได้*</strong>
        </h3>

        <!-- Incomplete Dates -->
        <div *ngIf="incompleteMobileDates && incompleteMobileDates.length" class="tw-mt-4">
          <h4 class="tw-text-[13px] tw-text-[#FF3B30] tw-font-medium tw-mb-2.5">*วันที่ยังไม่ได้กรอก Timesheet:*</h4>
          <ul class="tw-my-2.5 tw-pl-5 tw-list-disc">
            <li *ngFor="let date of incompleteMobileDates" class="tw-text-[#FF3B30] tw-mb-1 tw-text-sm">
              {{ date | date:'dd MMM yyyy' }}
            </li>
          </ul>
        </div>

        <!-- Partial Filled Dates -->
        <div *ngIf="partialFilledMobileDates && partialFilledMobileDates.length" class="tw-mt-4">
          <h4 class="tw-text-[13px] tw-text-[#FF9500] tw-font-medium tw-mb-2.5">*วันที่กรอกแล้วแต่ชั่วโมงไม่ครบ 8 ชม.:*
          </h4>
          <ul class="tw-my-2.5 tw-pl-5 tw-list-disc">
            <li *ngFor="let card of partialFilledMobileDates" class="tw-text-[#FF9500] tw-mb-1 tw-text-sm">
              {{ card.dateStr | date:'dd MMM yyyy' }} - {{ card.workingHours }} ชม.
            </li>
          </ul>
        </div>

        <!-- Complete Message -->
        <div *ngIf="(!incompleteMobileDates || incompleteMobileDates.length === 0) && 
                    (!partialFilledMobileDates || partialFilledMobileDates.length === 0)" class="tw-mt-4">
          <h4 class="tw-text-[13px] tw-text-[#34C759] tw-font-medium">✓ ข้อมูล Timesheet ครบถ้วนแล้ว!</h4>
        </div>
      </div>

      <!-- Save Button for Add Mode -->
      <div class="tw-pt-2 tw-flex tw-flex-col tw-items-center tw-gap-3">
        <button
          class="tw-bg-green-500 tw-w-[100px] tw-font-medium tw-text-sm tw-rounded-xl tw-px-2 tw-py-1 tw-text-white"
          [disabled]="!isMobileSaveValid()" [class.tw-opacity-50]="!isMobileSaveValid()"
          [class.tw-cursor-not-allowed]="!isMobileSaveValid()" (click)="saveMobileForm()">
          Save ({{ mobileFormCards.length }} timesheet{{ mobileFormCards.length > 1 ? 's' : '' }})
        </button>
      </div>
    </div>

    <!-- For View Mode - Show Timesheet Details with Revise Reason -->
    <div *ngIf="showMobileAddForm">

      <!-- Revise Reason Section (แสดงก่อนสุด) -->
      <div class="tw-mb-6" *ngIf="mainTimesheets?.reason && mainTimesheets.reason.trim()">
        <div class="tw-bg-white ">
          <h4 class="tw-text-[15px] tw-font-semibold tw-text-[#595970] tw-mb-3 tw-m-0">
            Reason: {{mainTimesheets?.reason}}
          </h4>

          <div class="tw-space-y-2.5">
            <p class="tw-text-sm tw-text-black tw-m-0 tw-leading-relaxed">
              <span class="tw-text-[#FF3B30] tw-font-semibold">ตัวหนังสือสีแดง</span> = กรณีการทำงานในวันหยุด
            </p>

            <p class="tw-text-sm tw-text-black tw-m-0 tw-leading-relaxed">
              <span class="tw-text-[#FF3B30] tw-font-semibold">* หลัง Date</span> = วันที่ Manager
              ได้แก้ไขข้อมูลเรียบร้อยแล้ว
            </p>
          </div>

          <p class="tw-text-sm tw-text-black tw-m-0 tw-leading-relaxed">
            <span class="tw-font-medium">*วันที่ยังไม่ได้กรอกเดือนที่แล้ว :</span>
            <span *ngIf="dateNotYetLastMonth && dateNotYetLastMonth.length">
              <span *ngFor="let date of dateNotYetLastMonth; let last = last">
                {{ date.date }}<span *ngIf="!last">, </span>
              </span>
            </span>
            <span *ngIf="!dateNotYetLastMonth || dateNotYetLastMonth.length === 0">-</span>
          </p>

          <p class="tw-text-sm tw-text-black tw-m-0 tw-leading-relaxed">
            <span class="tw-font-medium">*วันที่ยังไม่ได้กรอกเดือนนี้ :</span>
            <span *ngIf="dateNotYetThisMonth && dateNotYetThisMonth.length">
              <span *ngFor="let date of dateNotYetThisMonth; let last = last">
                {{ date.date }}<span *ngIf="!last">, </span>
              </span>
            </span>
            <span *ngIf="!dateNotYetThisMonth || dateNotYetThisMonth.length === 0">-</span>
          </p>
        </div>
      </div>

      <!-- Action Buttons Section for View Mode -->
      <div class="tw-pt-2 tw-flex tw-flex-col tw-items-center tw-gap-5">

        <!-- ADMIN -->
        <div *ngIf="rolename.includes('ADMIN')" class="tw-flex tw-gap-5 tw-justify-center tw-flex-wrap">

          <!-- Pending Status -->
          <ng-container *ngIf="mainTimesheets.status == 'P' && 
                         (mainTimesheets.positionId == 3 || 
                          mainTimesheets.positionId == 5 || 
                          mainTimesheets.leadId == currentUserID)">
            <button
              class="tw-bg-green-500 tw-w-[100px] tw-font-medium tw-text-sm tw-rounded-xl tw-px-2 tw-py-1 tw-text-white"
              (click)="onClickApprove(mainTimesheets)">
              Approve
            </button>

            <button
              class="tw-bg-blue-500 tw-w-[100px] tw-font-medium tw-text-sm tw-rounded-xl tw-px-2 tw-py-1 tw-text-white"
              (click)="onClickRevise(mainTimesheets)">
              Revise
            </button>
          </ng-container>

          <!-- Manager Approved Status -->
          <ng-container *ngIf="mainTimesheets.status == 'M'">
            <button
              class="tw-bg-green-500 tw-w-[100px] tw-font-medium tw-text-sm tw-rounded-xl tw-px-2 tw-py-1 tw-text-white"
              (click)="onClickApprove(mainTimesheets)">
              Approve
            </button>
          </ng-container>

          <!-- HR Revise -->
          <ng-container *ngIf="mainTimesheets.status == 'A' || mainTimesheets.status == 'M'">
            <button
              class="tw-bg-blue-500 tw-w-[100px] tw-font-medium tw-text-sm tw-rounded-xl tw-px-2 tw-py-1 tw-text-white"
              (click)="openDiaLogClick(modalHrRevise)">
              HR Revise
            </button>
          </ng-container>

          <!-- Submit -->
          <ng-container *ngIf="mainTimesheets.leadId == currentUserID && mainTimesheets.status == 'H'">
            <button
              class="tw-bg-green-500 tw-w-[100px] tw-font-medium tw-text-sm tw-rounded-xl tw-px-2 tw-py-1 tw-text-white"
              (click)="onClickPendingHrApprove(mainTimesheets)">
              Submit
            </button>
          </ng-container>

        </div>

        <!-- MANAGER -->
        <div *ngIf="rolename.includes('MANAGER')" class="tw-flex tw-gap-5 tw-justify-center tw-flex-wrap">

          <!-- Pending Status -->
          <ng-container *ngIf="mainTimesheets.status == 'P' &&
                         (mainTimesheets.positionId == 3 || 
                          mainTimesheets.positionId == 5 || 
                          mainTimesheets.leadId == currentUserID)">
            <button
              class="tw-bg-green-500 tw-w-[100px] tw-font-medium tw-text-sm tw-rounded-xl tw-px-2 tw-py-1 tw-text-white"
              (click)="onClickApprove(mainTimesheets)">
              Approve
            </button>

            <button
              class="tw-bg-blue-500 tw-w-[100px] tw-font-medium tw-text-sm tw-rounded-xl tw-px-2 tw-py-1 tw-text-white"
              (click)="onClickRevise(mainTimesheets)">
              Revise
            </button>
          </ng-container>

          <!-- Submit -->
          <ng-container *ngIf="mainTimesheets.status == 'H'">
            <button
              class="tw-bg-green-500 tw-w-[100px] tw-font-medium tw-text-sm tw-rounded-xl tw-px-2 tw-py-1 tw-text-white"
              (click)="onClickPendingHrApprove(mainTimesheets)">
              Submit
            </button>
          </ng-container>

        </div>

      </div>

    </div>
  </div>
</div>

<div class="pc">
  <div class="header pb-6 pt-5 pt-md-4" style="
    background-color: #fbb034;
    background-image: linear-gradient(315deg, #ffdd00 0%, #fbb034 74%);
  ">
    <div class="container-fluid">
      <!-- Header content can be added here if needed -->
    </div>
  </div>

  <div class="container-fluid" style="margin-top: -100px;">
    <!-- Table -->
    <div class="row">
      <div class="col" style="
    padding-top: 25px;
    padding-left: 35px;
    padding-right: 35px;
  ">
        <div class="card shadow" style="margin-top: 20px; margin-bottom: 60px; border-radius: 8px;">
          <div class="card-header border-0" style="background-color: white; padding: 20px; border-radius: 8px 8px 0 0;">
            <div class="timesheet-header-row">
              <div class="timesheet-title">
                <h3 style="color: black; margin-bottom: 0; font-size: 24px; font-weight: 600;">
                  <strong><a href="#/verify-timesheet" style="color: black">Verify Timesheet</a>
                    &nbsp; > &nbsp; {{ mainTimesheets.month | month }}&nbsp; >&nbsp;
                    Name: &nbsp; {{ firstnameTimesheet }}
                    {{ lastnameTimesheet }}</strong>
                </h3>
              </div>


              <button type="button" class="btn btn-secondary" (click)="gotoHomepage()"
                style="margin-top: 20px; margin-right: 15px;">
                < Back </button>
            </div>
            <div class="timesheet-info-left">
              <p class="manday text-truncate" style="margin-bottom: 0; font-size: 16px; color:#595970;">
                <strong>Timesheet Period</strong> &nbsp;&nbsp;&nbsp;
                <strong>{{ mainTimesheets.preriodFrom | date : "d MMMM y" }}</strong>
                &nbsp;&nbsp;&nbsp; <strong>To</strong> &nbsp;&nbsp;&nbsp;
                <strong>{{ mainTimesheets.preriodTo | date : "d MMMM y" }} </strong>
                &nbsp;&nbsp;&nbsp; <strong>จำนวน</strong>&nbsp;&nbsp;&nbsp;
                <strong>{{ manday }}</strong> &nbsp;&nbsp;&nbsp;<strong>Mandays</strong>
                &nbsp;&nbsp;&nbsp;
                <strong>Total Travel Expenses</strong>&nbsp;&nbsp;&nbsp;
                <strong>{{ (this.sumCost >= 1000) ? (this.sumCost | number:'1.0-0') : this.sumCost }}</strong>
              </p>
            </div>
            <div *ngIf="mainTimesheets?.reason && mainTimesheets.reason.trim()" style="margin-bottom: 15px;">
              <strong> Revise Reason: </strong> {{ mainTimesheets.reason }}
            </div>

            <div class="toolbar-section-inline">
              <div class="search-controls-left">
                <div class="date-input-wrapper">
                  <img src="assets/img/icons/search.png" alt="Search icon" class="search-icon" />
                  <app-date [min]="null" [max]="null" [ngModelVar]="searchStartDateValue" (date)="setStartDate($event)"
                    [wantHoliday]="false" [isNotEndDateUserInfo]="false" [placeholder]="'Start Date'"
                    [isDisable]="false" [moreClass]="'search-date-wrapper'">
                  </app-date>
                </div>

                <div class="date-input-wrapper">
                  <img src="assets/img/icons/search.png" alt="Search icon" class="search-icon" />
                  <app-date [min]="null" [max]="null" [ngModelVar]="searchEndDateValue" (date)="setEndDate($event)"
                    [wantHoliday]="false" [isNotEndDateUserInfo]="false" [placeholder]="'End Date'" [isDisable]="false"
                    [moreClass]="'search-date-wrapper'">
                  </app-date>
                </div>

                <button type="button" class="btn btn-primary" (click)="getSearchFilter()">
                  Search
                </button>

                <button type="button" class="btn btn-secondary" (click)="onClearSearch()">
                  Clear
                </button>
              </div>

              <div class="action-buttons-right">
                <button *ngIf="roleId.includes(1)" type="button" class="btn  btn-no-border btn-outline-secondary"
                  data-toggle="dropdown" aria-expanded="false" (click)="exportCost()">
                  <img src="assets/img/icons/Download.png" alt="Export"
                    style="width: 18px; vertical-align: middle; margin-right: 4px;" />
                  Export
                </button>

                <button *ngIf="mainTimesheets.status == 'H' && mainTimesheets.leadId == currentUserID" type="button"
                  class="btn btn-success" (click)="goToAddTimesheet(this.mainTimesheets)">
                  +Add Timesheet
                </button>
              </div>
            </div>
          </div>

          <div class="project-tabs-container">
            <div class="project-tabs-wrapper">
              <div class="project-tabs-scroll">
                <div *ngFor="let projectName of projectNames" (click)="changeProject(projectName)" role="button"
                  class="project-tab {{ currentTabProject == projectName ? 'active' : '' }}">
                  {{ projectName }}
                  <i *ngIf="projectName === 'Total'" class="fas fa-info-circle info-icon-tooltip"
                    [ngbTooltip]="tooltipTemplate" placement="right" container="body" tooltipClass="custom-tooltip"></i>
                </div>
              </div>
            </div>
          </div>
          <div class="table-responsive" id="managerTable">
            <table class="table align-items-center"
              style="border-collapse: separate; border-spacing: 0 0px; border: none; table-layout: fixed; width: 100%;">
              <thead class="thead-light sticky-header">
                <tr>
                  <th style="width: 4%" scope="col" class="text-center sticky-header"
                    (click)="sort(colId, booleanValue)">
                    No.
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                      class="bi bi-chevron-expand" viewBox="0 0 16 16">
                      <path fill-rule="evenodd"
                        d="M3.646 9.146a.5.5 0 0 1 .708 0L8 12.793l3.646-3.647a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 0-.708zm0-2.292a.5.5 0 0 0 .708 0L8 3.207l3.646 3.647a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 0 .708z" />
                    </svg>
                  </th>
                  <th style="width: 5%" scope="col" class="text-center sticky-header"
                    (click)="sort(colTransDate, booleanValue)">
                    Date
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                      class="bi bi-chevron-expand" viewBox="0 0 16 16">
                      <path fill-rule="evenodd"
                        d="M3.646 9.146a.5.5 0 0 1 .708 0L8 12.793l3.646-3.647a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 0-.708zm0-2.292a.5.5 0 0 0 .708 0L8 3.207l3.646 3.647a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 0 .708z" />
                    </svg>
                  </th>
                  <th style="width: 5%" scope="col" class="text-center sticky-header"
                    (click)="sort(colTimeFrom, booleanValue)">
                    Start
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                      class="bi bi-chevron-expand" viewBox="0 0 16 16">
                      <path fill-rule="evenodd"
                        d="M3.646 9.146a.5.5 0 0 1 .708 0L8 12.793l3.646-3.647a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 0-.708zm0-2.292a.5.5 0 0 0 .708 0L8 3.207l3.646 3.647a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 0 .708z" />
                    </svg>
                  </th>
                  <th style="width: 5%" scope="col" class="text-center sticky-header"
                    (click)="sort(colTimeTo, booleanValue)">
                    End
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                      class="bi bi-chevron-expand" viewBox="0 0 16 16">
                      <path fill-rule="evenodd"
                        d="M3.646 9.146a.5.5 0 0 1 .708 0L8 12.793l3.646-3.647a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 0-.708zm0-2.292a.5.5 0 0 0 .708 0L8 3.207l3.646 3.647a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 0 .708z" />
                    </svg>
                  </th>
                  <th style="width: 5%; font-size: 16px; white-space: normal;" scope="col"
                    class="text-center sticky-header" (click)="sort(colWorkingHours, booleanValue)">
                    Working<br>Hrs.
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                      class="bi bi-chevron-expand" viewBox="0 0 16 16">
                      <path fill-rule="evenodd"
                        d="M3.646 9.146a.5.5 0 0 1 .708 0L8 12.793l3.646-3.647a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 0-.708zm0-2.292a.5.5 0 0 0 .708 0L8 3.207l3.646 3.647a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 0 .708z" />
                    </svg>
                  </th>
                  <th style="width: 18%" scope="col" class="text-center sticky-header"
                    (click)="sort(colProjectName, booleanValue)">
                    Project
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                      class="bi bi-chevron-expand" viewBox="0 0 16 16">
                      <path fill-rule="evenodd"
                        d="M3.646 9.146a.5.5 0 0 1 .708 0L8 12.793l3.646-3.647a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 0-.708zm0-2.292a.5.5 0 0 0 .708 0L8 3.207l3.646 3.647a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 0 .708z" />
                    </svg>
                  </th>
                  <th style="width: 18%" scope="col" class="text-center sticky-header">
                    Site cost
                  </th>
                  <th style="width: 22%" scope="col" class="text-center sticky-header"
                    (click)="sort(colDescription, booleanValue)">
                    Description
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                      class="bi bi-chevron-expand" viewBox="0 0 16 16">
                      <path fill-rule="evenodd"
                        d="M3.646 9.146a.5.5 0 0 1 .708 0L8 12.793l3.646-3.647a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 0-.708zm0-2.292a.5.5 0 0 0 .708 0L8 3.207l3.646 3.647a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 0 .708z" />
                    </svg>
                  </th>
                  <th class="text-center sticky-header" style="width: 7%"
                    *ngIf="this.mainTimesheets.status == 'H' && mainTimesheets.leadId == currentUserID">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody style="word-break: break-all; white-space: normal">
                <tr *ngFor="let timesheet of timesheets; let i = index" style="height: 60px;">
                  <td style="word-break: break-all; white-space: normal; width: 4%" class="text-center" [ngStyle]="{
                        color:
                          checkVacation(timesheet.transDate) ||
                          getday1(timesheet.transDate) === 0 ||
                          getday1(timesheet.transDate) === 6
                            ? 'red'
                            : duplicateDays[getday(timesheet.transDate)]
                            ? 'orange'
                            : 'black'
                      }">
                    {{ i + 1 + startIndex }}
                    <span *ngIf="
                          checkIsUpdateByManager(timesheet.updatedBy) === true
                        " class="text-danger">*</span>
                  </td>
                  <td
                    style="word-break: break-all; white-space: nowrap; width: 5%; overflow: hidden; text-overflow: ellipsis;"
                    class="text-center" [ngStyle]="{
                        color:
                          checkVacation(timesheet.transDate) ||
                          getday1(timesheet.transDate) === 0 ||
                          getday1(timesheet.transDate) === 6
                            ? 'red'
                            : duplicateDays[getday(timesheet.transDate)]
                            ? 'orange'
                            : 'black'
                      }">
                    {{ timesheet.transDate | date : "d MMM" }}
                  </td>
                  <td style="word-break: break-all; white-space: normal; width: 5%" class="text-center" [ngStyle]="{
                        color:
                          checkVacation(timesheet.transDate) ||
                          getday1(timesheet.transDate) === 0 ||
                          getday1(timesheet.transDate) === 6
                            ? 'red'
                            : duplicateDays[getday(timesheet.transDate)]
                            ? 'orange'
                            : 'black'
                      }">
                    {{ formatTime(timesheet.timeFrom) }}
                  </td>
                  <td style="word-break: break-all; white-space: normal; width: 5%" class="text-center" [ngStyle]="{
                        color:
                          checkVacation(timesheet.transDate) ||
                          getday1(timesheet.transDate) === 0 ||
                          getday1(timesheet.transDate) === 6
                            ? 'red'
                            : duplicateDays[getday(timesheet.transDate)]
                            ? 'orange'
                            : 'black'
                      }">
                    {{ formatTime(timesheet.timeTo) }}
                  </td>
                  <td style="word-break: break-all; white-space: normal; width: 5%" class="text-center" [ngStyle]="{
                        color:
                          checkVacation(timesheet.transDate) ||
                          getday1(timesheet.transDate) === 0 ||
                          getday1(timesheet.transDate) === 6
                            ? 'red'
                            : duplicateDays[getday(timesheet.transDate)]
                            ? 'orange'
                            : 'black'
                      }">
                    {{ timesheet.workingHours }}
                  </td>
                  <td class="text-center" style="width: 18%" [ngStyle]="{
                        color:
                          checkVacation(timesheet.transDate) ||
                          getday1(timesheet.transDate) === 0 ||
                          getday1(timesheet.transDate) === 6
                            ? 'red'
                            : duplicateDays[getday(timesheet.transDate)]
                            ? 'orange'
                            : 'black'
                      }">
                    {{ timesheet.projectName }}
                  </td>
                  <td class="text-center truncate-cell" style="width: 18%;" [ngStyle]="{
                        color:
                          checkVacation(timesheet.transDate) ||
                          getday1(timesheet.transDate) === 0 ||
                          getday1(timesheet.transDate) === 6
                            ? 'red'
                            : duplicateDays[getday(timesheet.transDate)]
                            ? 'orange'
                            : 'black'
                      }">
                    <span *ngIf="timesheet.siteName">
                      {{ timesheet.siteName}} - {{ timesheet.costOnsite != null ? timesheet.costOnsite : '-' }}
                    </span>
                    <span *ngIf="!timesheet.siteName">
                      -
                    </span>
                  </td>
                  <td style="word-break: break-all; white-space: normal; width: 22%" class="text-center" [ngStyle]="{
                        color:
                          checkVacation(timesheet.transDate) ||
                          getday1(timesheet.transDate) === 0 ||
                          getday1(timesheet.transDate) === 6
                            ? 'red'
                            : duplicateDays[getday(timesheet.transDate)]
                            ? 'orange'
                            : 'black'
                      }">
                    {{ timesheet.description }}
                  </td>
                  <td style="width: 7%; text-align: center; vertical-align: middle;"
                    *ngIf="this.mainTimesheets.status == 'H' && mainTimesheets.leadId == currentUserID">
                    <img src="assets/img/icons/edit.png" role="button" width="40px" height="40px"
                      (click)="goToEditTimesheet(modalEdit)" style="display: block; margin: 0 auto;">
                    <ng-template #modalEdit let-modalUp>
                      <div class="popup-main">
                        <app-popup-edit [propModal]="modalUp" [timeId]="timesheet.id">
                        </app-popup-edit>
                      </div>
                    </ng-template>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <nav aria-label="Page navigation example">
            <div style="display: flex; justify-content: flex-end; align-items: center; padding: 20px 20px 0 20px;">
              <!-- Pagination -->
              <ul class="pagination justify-content-end">
                <!-- <li *ngFor="let in of counter(pagingLength); let i = index" class="page-item">
                <a style="cursor: hand; cursor: pointer" class="page-link" (click)="changePage(i)"
                  [ngClass]="{ 'selected-page': i === selectedPage }" (click)="selectedPage = i">{{ i + 1 }}</a>
              </li> -->
                <div class="d-flex justify-content-center align-items-center mr-2">
                  <span class="text-dark mr-1">Page</span>
                  <span class="text-dark">{{ currentPage + 1 }} / {{ pagingLength }}</span>
                </div>
                <li class="page-item widthpage" [class.disabled]="currentPage === 0">
                  <i class="fa-solid fa-backward-step page-link" (click)="setPage(0)" role="button"></i>
                </li>
                <li class="page-item widthpage" [class.disabled]="currentPage === 0">
                  <i class="fa-solid fa-caret-left page-link" (click)="setPage(currentPage - 1)" role="button"></i>
                </li>
                <li class="page-item widthpage" *ngFor="let page of pages" [class.active]="page === currentPage + 1">
                  <a class="page-link page-number-btn" (click)="setPage(page - 1)" role="button">{{
                    page
                    }}</a>
                </li>
                <li class="page-item widthpage" [class.disabled]="currentPage === pagingLength - 1">
                  <i class="fa-solid fa-caret-right page-link" (click)="setPage(currentPage + 1)" role="button"></i>
                </li>
                <li class="page-item " [class.disabled]="currentPage === pagingLength - 1">
                  <i class="fa-solid fa-forward-step page-link" (click)="setPage(pagingLength - 1)" role="button"></i>
                </li>
              </ul>
            </div>
          </nav>

          <!-- Warning messages for incomplete days (HR Revised status only) -->
          <div *ngIf="mainTimesheets.status == 'H'" style="padding: 20px; text-align: left;">
            <div *ngIf="dateNotYetThisMonth && dateNotYetThisMonth.length" style="margin-bottom: 10px;">
              <h3 style="color: #595970; font-weight: 500;">
                *วันที่กรอกไม่ครบหรือยังไม่ได้กรอกเดือนนี้:
                <span *ngFor="let date of dateNotYetThisMonth; let last = last">
                  {{ date.date }}<span *ngIf="!last">, </span>
                </span>
              </h3>
            </div>

            <div *ngIf="dateNotYetLastMonth && dateNotYetLastMonth.length" style="margin-bottom: 10px;">
              <h3 style="color: #595970; font-weight: 500;">
                *วันที่กรอกไม่ครบหรือยังไม่ได้กรอกเดือนที่แล้ว:
                <span *ngFor="let date of dateNotYetLastMonth; let last = last">
                  {{ date.date }}<span *ngIf="!last">, </span>
                </span>
              </h3>
            </div>
          </div>

          <!-- Action buttons section -->
          <div class="submit-container flex justify-center items-center">
            <div style="text-align: center; justify-content: center; align-items: center; display: flex;"
              *ngIf="rolename.includes('ADMIN')">
              <button *ngIf="this.mainTimesheets.status !== 'M' &&
                    mainTimesheets.status == 'P' &&
                    (mainTimesheets.positionId == 3 ||
                      mainTimesheets.positionId == 5 ||
                      mainTimesheets.leadId == this.currentUserID)" type="button" class="btn btn-success"
                (click)="onClickApprove(mainTimesheets)">
                Approve
              </button>
              &nbsp;&nbsp;
              <button *ngIf="this.mainTimesheets.status == 'M'" type="button" class="btn btn-success"
                (click)="onClickApprove(mainTimesheets)">
                Approve
              </button>
              &nbsp;&nbsp;
              <button *ngIf="mainTimesheets.status !== 'M' &&
                    mainTimesheets.status == 'P' &&
                    (mainTimesheets.positionId == 3 ||
                      mainTimesheets.positionId == 5 ||
                      mainTimesheets.leadId == this.currentUserID)" type="button" class="btn btn-primary"
                data-bs-toggle="modal" data-bs-target="#staticBackdrop" (click)="onClickRevise(mainTimesheets)">
                Revise
              </button>
              &nbsp;&nbsp;
              <button hidden *ngIf="mainTimesheets.status == 'P' &&
                    (mainTimesheets.positionId == 3 ||
                      mainTimesheets.positionId == 5 ||
                      mainTimesheets.leadId == this.currentUserID)" type="button" class="btn btn-danger"
                data-bs-toggle="modal" data-bs-target="#staticBackdrop" (click)="onClickReject(mainTimesheets)">
                Reject
              </button>
              &nbsp;&nbsp;
              <button *ngIf="
                  (this.mainTimesheets.status == 'A' ||
                  this.mainTimesheets.status == 'M')
                " type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#staticBackdrop"
                (click)="openDiaLogClick(modalHrRevise)">
                HR Revise
              </button>

              <button *ngIf="
                  this.mainTimesheets.leadId == this.currentUserID &&
                  mainTimesheets.status == 'H'
                " type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#staticBackdrop"
                (click)="onClickPendingHrApprove(mainTimesheets)" [disabled]="!isSubmitBtnDisabled">
                Submit
              </button>
              &nbsp;&nbsp;
            </div>

            <div style="text-align: center; justify-content: center; align-items: center; display: flex;"
              *ngIf="rolename.includes('MANAGER')">
              <button *ngIf="mainTimesheets.status == 'P'" type="button" class="btn btn-success"
                (click)="onClickApprove(mainTimesheets)">
                Approve
              </button>
              &nbsp;&nbsp;
              <button *ngIf="mainTimesheets.status == 'P'" type="button" class="btn btn-primary" data-bs-toggle="modal"
                data-bs-target="#staticBackdrop" (click)="openDiaLogClick(modalManagerRevise)">
                Revise
              </button>
              <ng-template #modalManagerRevise let-modalUp>
                <div>
                  <div class="modal-header">
                    <h2 class="modal-title">Reason</h2>
                    <i style="cursor: pointer; font-size: 20px" class="fa-solid fa-xmark" data-bs-dismiss="modal"
                      (click)="modalUp.dismiss('Cross click')"></i>
                  </div>
                  <div class="modal-body" style="padding-bottom: 16px; padding-top: 0px;">
                    <textarea class="mb-3 tw-mx-3" style="min-height: 150px; resize: none" class="form-control"
                    [(ngModel)]="reason" placeholder="Reason"></textarea>
                    <p *ngIf="isReasonInvalid" class="tw-font-bold text-danger tw-flex tw-justify-center tw-mt-1">*Require Your Reason</p>
                    <div class="d-flex justify-content-center mt-3">
                      <button type="button" class="btn btn-primary"
                        (click)="onClickRevise(mainTimesheets)">
                        Confirm
                      </button>
                      <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                        (click)="modalUp.dismiss('Cross click')">
                        Back
                      </button>
                    </div>
                  </div>
                </div>
              </ng-template>
              &nbsp;&nbsp;
              <button hidden *ngIf="mainTimesheets.status == 'P'" type="button" class="btn btn-danger"
                data-bs-toggle="modal" data-bs-target="#staticBackdrop" (click)="onClickReject(mainTimesheets)">
                Reject
              </button>
              &nbsp;&nbsp;
              <button *ngIf="this.mainTimesheets.status == 'H'" type="button" class="btn btn-primary"
                data-bs-toggle="modal" data-bs-target="#staticBackdrop"
                (click)="onClickPendingHrApprove(mainTimesheets)" [disabled]="!isSubmitBtnDisabled">
                Submit
              </button>
              &nbsp;&nbsp;
            </div>


          </div>

        </div>
      </div>
    </div>
  </div>

  <!-- HR Revise Modal Template -->
  <ng-template #modalHrRevise let-modalUp>
    <div>
      <div class="modal-header">
        <h2 class="modal-title">Reason</h2>
          <i style="cursor: pointer; font-size: 20px" class="fa-solid fa-xmark" data-bs-dismiss="modal"
            (click)="modalUp.dismiss('Cross click')"></i>
      </div>
      <div class="modal-body" style="padding-bottom: 16px; padding-top: 0px;">
        <textarea class="mb-3 tw-mx-3" style="min-height: 150px; resize: none" class="form-control"
          [(ngModel)]="reason" placeholder="Reason"></textarea>
          <p *ngIf="isReasonInvalid" class="tw-font-bold text-danger tw-flex tw-justify-center tw-mt-1">*Require Your Reason</p>
          <div class="d-flex justify-content-center mt-3">
            <button type="button" class="btn btn-primary"
              (click)="onClickHrRevise(mainTimesheets)">
              Confirm
            </button>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
              (click)="modalUp.dismiss('Cross click')">
              Back
            </button>
          </div>
      </div>
    </div>
  </ng-template>

  <!-- ###########################################################  -->
  <table hidden #tableReportCost style="text-align: center">
    <thead style="background-color: whitesmoke">
      <tr>
        <th colspan="9">
          <h1>รายงานค่าใช้จ่ายในการปฏิบัติงาน</h1>
        </th>
      </tr>
      <tr>
        <th colspan="9">
          <h1><a>ประจำเดือน</a>&nbsp; {{ mainTimesheets.month | month }}</h1>
        </th>
      </tr>
      <tr></tr>

      <tr>
        <th colspan="2">ชื่อพนักงาน</th>
        <th colspan="2">{{ firstnameTimesheet }} {{ lastnameTimesheet }}</th>
        <th></th>
        <th colspan="1">ตำแหน่ง</th>
        <th colspan="3">{{ positionNameTimesheet }}</th>
      </tr>
      <tr></tr>
      <tr>
        <th colspan="2">วันที่จัดทำรายงาน</th>
        <th colspan="2">{{ currentDate | date : "dd/MM/yyyy" }}</th>
        <th></th>
        <th colspan="1">ฝ่าย</th>
        <th colspan="3">Profressional Service</th>
      </tr>
      <tr></tr>

      <tr>
        <td colspan="1">ที่</td>
        <td colspan="1">วันที่</td>
        <td colspan="1">ชื่อโครงการ</td>
        <td colspan="1">รายละเอียด</td>
        <td colspan="1">ต้นทาง</td>
        <td colspan="1">ปลายทาง</td>
        <td colspan="1">ค่าเดินทาง</td>
        <td colspan="1">อื่นๆ</td>
        <td colspan="1">หมายเหตุ</td>
      </tr>
    </thead>

    <tbody style="background-color: white">
      <tr *ngFor="let timesheet of timesheetexport; let i = index">
        <td>{{ i + 1 + startIndex }}</td>
        <td>{{ timesheet.transDate | date : "d MMMM y" }}</td>
        <td>{{ timesheet.projectName }}</td>
        <td>{{ timesheet.description }}</td>
        <td>บริษัท B3 Technology</td>
        <td>{{ timesheet.projectName }}</td>
        <td>{{ timesheet.siteName}} - {{ timesheet.costOnsite != null ? timesheet.costOnsite : '' }}</td>
        <td>-</td>
        <td>-</td>
      </tr>
      <tr>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td>
          {{ getTotalCost() }}
        </td>
        <td>-</td>
        <td>-</td>
      </tr>
      <tr>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td colspan="3">
          {{ getTotalCost() }}
        </td>
      </tr>
      <tr></tr>
      <tr>
        <td>จำนวนเงิน</td>
        <td></td>
        <td></td>
        <td></td>
        <td colspan="5">
          {{ getTotalCostText() }}
        </td>
      </tr>
      <tr></tr>
      <tr></tr>
      <tr>
        <td colspan="3">
          {{ firstnameTimesheet }} {{ lastnameTimesheet }}/{{
          currentDate | date : "dd/MM/yyyy"
          }}
        </td>
        <td colspan="3">....................../.................</td>
        <td colspan="3">....................../.................</td>
      </tr>
      <tr>
        <td colspan="3">ผู้ขอเบิก/วันที่</td>
        <td colspan="3">ผู้รับรอง/วันที่</td>
        <td colspan="3">ผู้รับรอง/วันที่</td>
      </tr>
      <tr></tr>
      <tr></tr>
      <tr>
        <td colspan="2">หมายเหตุอื่นๆ</td>
        <td colspan="7">
          ................................................................................
        </td>
      </tr>
    </tbody>
  </table>
  <!-- ###########################################################  -->

  <!-- Tooltip template for info icon -->
  <ng-template #tooltipTemplate>
    <div style="text-align: left; line-height: 1.6;">
      <div style="margin-bottom: 8px;">
        <strong style="color: #dc3545;">ตัวหนังสือสีแดง</strong> = กรณีการทำงานในวันหยุด
      </div>
      <div>
        <strong style="color: #dc3545;">* หลัง NO.</strong> = วันที่ MANAGER ได้แก้ไขข้อมูลเรียบร้อยแล้ว
      </div>
    </div>
  </ng-template>

</div>